import { hasRole } from 'utils/functions'

export const employeeRoutes = [
  {
    path: '/colaboradores/:id?',
    name: 'Employees',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true
    },
    component: () => import(/* webpackChunkName: 'employees-page' */ 'views/EmployeesPage'),
    beforeEnter (to, from, next) {
      if (!hasRole('employee', 'ROLE_GET_EMPLOYEE')) {
        return next({ name: 'Dashboard' })
      }

      if (to.params.id === 'cadastrar') {
        return next({
          name: 'Employee',
          params: { type: 'cadastrar' }
        })
      }

      return next()
    }
  },
  {
    path: '/politica-de-credito-em-massa',
    name: 'EmployeeMassCreditPolicy',
    meta: {
      requiresAuth: true,
      chat: true
    },
    component: () => import(/* webpackChunkName: 'employee-mass-credit-policy-page' */ 'views/EmployeeMassCreditPolicyPage'),
    beforeEnter (to, from, next) {
      return !hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE')
        ? next({ name: 'Home' })
        : next()
    }
  },
  {
    path: '/colaborador/:type/:id?',
    name: 'Employee',
    meta: {
      requiresAuth: true,
      chat: true
    },
    component: () => import(/* webpackChunkName: 'employee-page' */ 'views/EmployeePage')
  },
  {
    path: '/importacao-em-massa/colaboradores/:id?',
    name: 'EmployeeBulkOperation',
    meta: {
      requiresAuth: true,
      chat: true
    },
    component: () => import(/* webpackChunkName: 'employee-bulk-operation-page' */ 'views/EmployeeBulkOperationPage'),
    beforeEnter (to, from, next) {
      if (
        hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_UPLOAD') &&
        hasRole('company', 'ROLE_POST_COMPANY_COMPANYID_BULKOPERATION_ID_EXECUTE')
      ) {
        return next()
      }

      next({ name: 'Home' })
    }
  }
]
